import { useUser } from '@folklore/auth';
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
// import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import * as AppPropTypes from '../../../lib/PropTypes';

import { useContest } from '../../../contexts/ContestContext';
import DrawCard from '../../items/DrawCard';
import PageTitle from '../../partials/PageTitle';
import PrizeCard from '../../partials/PrizeCard';
import SportParticipationsStats from '../../partials/SportParticipationsStats';
import TodaysPoints from '../../partials/TodaysPoints';

import styles from '../../../../styles/pages/account-nfl.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

function AccountNFL({ page }) {
    const {
        outcome: { hasLeaderboard = false },
    } = useContest();
    const user = useUser();
    const { stats, draws, points } = user || {};
    const route = useUrlGenerator();

    const { title, prizes } = page || {};
    const { pointsToday = null, leaderboardPosition = null, leaderboardTotal = null } = stats || {};

    const finalDraws = useMemo(
        () =>
            (draws || []).filter(
                ({ active = true, type = null } = {}) => active && type !== 'venues',
            ),
        [draws],
    );

    return (
        <div className={classNames([styles.container])}>
            <PageTitle className={styles.pageTitle} title={title} />
            {leaderboardPosition !== null ? (
                <div className={styles.leaderboardPosition}>
                    <Link href={route('leaderboard')}>
                        <FormattedMessage
                            defaultMessage="Your rank : {position}/{total}"
                            description="Leaderboard position"
                            values={{
                                position: leaderboardPosition,
                                total: leaderboardTotal,
                            }}
                        />
                    </Link>
                </div>
            ) : null}
            {pointsToday !== null && !hasLeaderboard ? (
                <TodaysPoints className={styles.todaysGamePoints} points={pointsToday} />
            ) : null}
            <div className={styles.draws}>
                {(finalDraws || []).map((draw, drawIndex) => (
                    <div key={`draw-${drawIndex + 1}`} className={styles.draw}>
                        <DrawCard draw={draw} className={styles.drawCard} />
                    </div>
                ))}
            </div>
            {prizes !== null && prizes.length > 0 ? (
                <div className={styles.historyContainer}>
                    <h2 className={styles.sectionTitle}>
                        <FormattedMessage
                            defaultMessage="Scoreboard"
                            description="Account section title"
                        />
                    </h2>
                    <div className={styles.sectionSubtitle}>
                        <FormattedMessage
                            defaultMessage="Prizes won"
                            description="Account section subtitle"
                        />
                    </div>
                    <div className={styles.prizes}>
                        {(prizes || []).map((prize, prizeIndex) => {
                            const {
                                prize: prizeObject,
                                uuid: prizeUuid,
                                claimed: prizeClaimed,
                            } = prize || {};
                            const { image: prizeImage, name: prizeName } = prizeObject || {};

                            return (
                                <PrizeCard
                                    className={styles.prize}
                                    key={`prize-${prizeIndex + 1}`}
                                    href={route('prize', { participant_prize: prizeUuid })}
                                    name={prizeName}
                                    image={prizeImage}
                                    status={
                                        prizeClaimed ? (
                                            <FormattedMessage
                                                defaultMessage="Claimed"
                                                description="Prize status label"
                                            />
                                        ) : null
                                    }
                                />
                            );
                        })}
                    </div>
                </div>
            ) : null}
            <SportParticipationsStats
                className={styles.stats}
                titleClassName={styles.sectionTitle}
                itemClassName={styles.statsItem}
                stats={stats}
                points={points}
            />
        </div>
    );
}

AccountNFL.propTypes = propTypes;

export default AccountNFL;
